import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { handleRequestHelper } from '../../../../utils/helpers';
import api from '../../../../api/api';
import { getEnviroment } from '../../../../utils/utils';
import { ENVIRONMENTS } from '../../../../constants/types';

const PROD_MODO_SCRIPT_URL = 'https://ecommerce-modal.modo.com.ar/bundle.js';
const PREPROD_MODO_SCRIPT_URL = 'https://ecommerce-modal.preprod.modo.com.ar/bundle.js';

export const useModoCheckout = () => {
  const { externalId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [shouldShowError, setShouldShowError] = useState(false);
  const env = getEnviroment();
  const modoScriptUrl =
    env === ENVIRONMENTS.PRODUCTION ? PROD_MODO_SCRIPT_URL : PREPROD_MODO_SCRIPT_URL;

  const openPaymentSDK = (modalData, order) => {
    const { Event: event } = order;
    const modalObject = {
      version: '2',
      qrString: modalData.qrString,
      checkoutId: modalData.checkoutId,
      deeplink: {
        url: modalData.deeplink,
        callbackURL: `https://${window.location.hostname}/evento/${event.urlName}/resultado-operacion?code=200&externalId=${externalId}`,
        callbackURLSuccess: `https://${window.location.hostname}/evento/${event.urlName}/resultado-operacion?code=200&externalId=${externalId}`,
      },
      callbackURL: `https://${window.location.hostname}/evento/${event.urlName}/resultado-operacion?code=200&externalId=${externalId}`,
      refreshData: () => {
        // Modo SDK does not support refreshData, so we need to reload the page
        window.location.reload();
      },
      onCancel() {
        setIsLoading(false);
      },
      onClose() {
        setIsLoading(false);
      },
    };
    window.ModoSDK.modoInitPayment(modalObject);
  };

  const createPaymentRequest = async () => {
    setIsLoading(true);
    setShouldShowError(false);
    handleRequestHelper({
      endpoint: () => api.createLineModoPaymentRequest(externalId),
      onSuccess: ({ paymentRequest, order }) => {
        openPaymentSDK(paymentRequest, order);
      },
      onFailure: () => {
        setShouldShowError(true);
        setIsLoading(false);
      },
    });
  };

  const handleScriptLoad = () => {
    createPaymentRequest();
  };

  useEffect(() => {
    const script = document.createElement('script');

    script.src = modoScriptUrl;

    script.async = true;

    script.addEventListener('load', handleScriptLoad);

    document.body.appendChild(script);

    return () => {
      try {
        if (script && script.parentNode === document.body) {
          document.body.removeChild(script);
        }
      } catch (error) {
        setShouldShowError(true);
        setIsLoading(false);
        console.warn('Error removing script element:', error);
      }
    };
  }, []);

  return {
    isLoading,
    shouldShowError,
  };
};
